import React from 'react'
import { CollaboHeader } from 'src/components/Collabo/CollaboHeader'
import { CollaboToggle } from 'src/components/Collabo/CollaboToggle'
import SEO from 'src/seo'

const Collabo = () => {
  return (
    <div>
      <SEO title="Collabo" />
      <CollaboHeader />
      <CollaboToggle />
    </div>
  )
}
export { Collabo }
